module.exports = __webpack_public_path__ + "img/service-details.d1995bd7.webp";